import { type DateInput, dayToString } from '@/utils/date';

import type { GetHealthOverviewParams } from './overviewTypes';
import { resolveHealthDaypartTag } from './overviewTypes';

export interface RawHealthOverviewParams {
    daypartTag?: string;
    from?: DateInput;
    to?: DateInput;
    /** The fish group the page is about (`fg`); without it the data is the cage's. */
    fishGroupId?: number;
}

/** Coerce cage-filter dates / strings into `YYYY-MM-DD` for the health API. */
export function buildHealthOverviewQueryParams(
    params: RawHealthOverviewParams
): GetHealthOverviewParams {
    const result: GetHealthOverviewParams = {
        daypartTag: resolveHealthDaypartTag(params.daypartTag),
    };

    const from = params.from != null ? dayToString(params.from) : undefined;
    const to = params.to != null ? dayToString(params.to) : undefined;

    if (from) {
        result.from = from;
    }
    if (to) {
        result.to = to;
    }
    if (params.fishGroupId != null) {
        result.fishGroupId = params.fishGroupId;
    }

    return result;
}
